import { all, fork, put, takeLatest, call } from 'redux-saga/effects';
import {
    getDelayedFacilities,
    getDelayedFacilitiesReport,
    getShipmentTrackingRecords,
    getShipmentTrackingReport,
    getAggregatedDelayedShipments,
    getAggregatedDelayedShipmentsReport,
    getAddressReport,
    getAddressReportFile,
} from '../../helpers';
import {
    trackingReportsApiResponseSuccess,
    trackingReportsApiResponseError,
} from './actions';
import { TrackingReportsActionTypes } from './constants';
import { addToast } from '../actions';
import { paginationHeadersResponse } from '../../helpers/mappers/pagination';

export function* getDelayedFacilitiesSaga({ payload: { query } }) {
    try {
        const response = yield call(getDelayedFacilities, query);
        const delayedFacilities = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REQUEST, { delayedFacilities, pagination }));
    } catch (error) {
        yield put(addToast({ desc: error.errors[0].message, type: 'error' }));
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REQUEST, error));
    }
}

export function* getDelayedFacilitiesReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getDelayedFacilitiesReport, query);
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REPORT_REQUEST, response.data));
    } catch (error) {
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REPORT_REQUEST, error));
    }
}

export function* getShipmentTrackingRecordsSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentTrackingRecords, query);
        const shipmentTrackingRecords = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_RECORDS_REQUEST, { shipmentTrackingRecords, pagination }));
    } catch (error) {
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_RECORDS_REQUEST, error));
    }
}

export function* getShipmentTrackingReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getShipmentTrackingReport, query);
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_REPORT_REQUEST, response.data));
    } catch (error) {
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_REPORT_REQUEST, error));
    }
}

export function* getAggregatedDelayedShipmentsSaga({ payload: { query } }) {
    try {
        const response = yield call(getAggregatedDelayedShipments, query);
        const aggregatedDelayedShipments = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST, { aggregatedDelayedShipments, pagination }));
    } catch (error) {
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST, error));
    }
}

export function* getAggregatedDelayedShipmentsReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getAggregatedDelayedShipmentsReport, query);
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST, response.data));
    } catch (error) {
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST, error));
    }
}

export function* getAddressReportSaga({ payload: { query } }) {
    try {
        const response = yield call(getAddressReport, query);
        const addressReport = response.data;
        const pagination = { ...paginationHeadersResponse(response.headers), ...query };
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_ADDRESS_REPORT_REQUEST, { addressReport, pagination }));
    } catch (error) {
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_ADDRESS_REPORT_REQUEST, error));
    }
}

export function* getAddressReportFileSaga({ payload: { query } }) {
    try {
        const response = yield call(getAddressReportFile, query);
        yield put(trackingReportsApiResponseSuccess(TrackingReportsActionTypes.GET_ADDRESS_REPORT_FILE_REQUEST, response.data));
    } catch (error) {
        yield put(trackingReportsApiResponseError(TrackingReportsActionTypes.GET_ADDRESS_REPORT_FILE_REQUEST, error));
    }
}

export function* watchGetDelayedFacilitiesSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REQUEST, getDelayedFacilitiesSaga);
}

export function* watchGetDelayedFacilitiesReportSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_DELAYED_FACILITIES_REPORT_REQUEST, getDelayedFacilitiesReportSaga);
}

export function* watchGetShipmentTrackingRecordsSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_RECORDS_REQUEST, getShipmentTrackingRecordsSaga);
}

export function* watchGetShipmentTrackingReportSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_SHIPMENT_TRACKING_REPORT_REQUEST, getShipmentTrackingReportSaga);
}

export function* watchGetAggregatedDelayedShipmentsSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REQUEST, getAggregatedDelayedShipmentsSaga);
}

export function* watchGetAggregatedDelayedShipmentsReportSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_AGGREGATED_DELAYED_SHIPMENTS_REPORT_REQUEST, getAggregatedDelayedShipmentsReportSaga);
}

export function* watchGetAddressReportSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_ADDRESS_REPORT_REQUEST, getAddressReportSaga);
}

export function* watchGetAddressReportFileSaga() {
    yield takeLatest(TrackingReportsActionTypes.GET_ADDRESS_REPORT_FILE_REQUEST, getAddressReportFileSaga);
}

export function* trackingReportsSaga() {
    yield all([
        fork(watchGetDelayedFacilitiesSaga),
        fork(watchGetDelayedFacilitiesReportSaga),
        fork(watchGetShipmentTrackingRecordsSaga),
        fork(watchGetShipmentTrackingReportSaga),
        fork(watchGetAggregatedDelayedShipmentsSaga),
        fork(watchGetAggregatedDelayedShipmentsReportSaga),
        fork(watchGetAddressReportSaga),
        fork(watchGetAddressReportFileSaga),
    ]);
}

export default trackingReportsSaga;
